export var formattedDate = function formattedDate(date) {
  if (!date) return null;
  var parsedDate = new Date(date);
  if (Number.isNaN(parsedDate.getTime()) || parsedDate < new Date()) {
    return null;
  }
  return parsedDate.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: 'short'
  });
};